import { isPublisher } from '~/helpers'

import AdvertiserAudienceTabs from './Advertiser'
import PublisherAudienceTabs from './Publisher'

const AudienceTabs = () =>
  isPublisher() ? <PublisherAudienceTabs /> : <AdvertiserAudienceTabs />

export default AudienceTabs
